import { render, staticRenderFns } from "./ConsumptionInfoModal.global.vue?vue&type=template&id=5ac720c0&scoped=true&lang=pug&"
import script from "./ConsumptionInfoModal.global.vue?vue&type=script&lang=ts&"
export * from "./ConsumptionInfoModal.global.vue?vue&type=script&lang=ts&"
import style0 from "./ConsumptionInfoModal.global.vue?vue&type=style&index=0&id=5ac720c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ac720c0",
  null
  
)

export default component.exports